var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 199,
    viewBox: "0 0 362 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -53.3876,
    y: 27.012,
    width: 102,
    height: 177,
    rx: 51,
    transform: "rotate(-15 -53.3876 27.012)",
    stroke: "url(#paint0_linear_160_23)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -26.1074,
    y: 27.012,
    width: 102,
    height: 177,
    rx: 51,
    transform: "rotate(-15 -26.1074 27.012)",
    stroke: "url(#paint1_linear_160_23)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.892646,
    y: 27.012,
    width: 102,
    height: 177,
    rx: 51,
    transform: "rotate(-15 0.892646 27.012)",
    stroke: "url(#paint2_linear_160_23)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8926,
    y: 27.012,
    width: 102,
    height: 177,
    rx: 51,
    transform: "rotate(-15 27.8926 27.012)",
    stroke: "url(#paint3_linear_160_23)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54.8926,
    y: 27.012,
    width: 102,
    height: 177,
    rx: 51,
    transform: "rotate(-15 54.8926 27.012)",
    stroke: "url(#paint4_linear_160_23)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 81.8926,
    y: 27.012,
    width: 102,
    height: 177,
    rx: 51,
    transform: "rotate(-15 81.8926 27.012)",
    stroke: "url(#paint5_linear_160_23)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 108.893,
    y: 27.012,
    width: 102,
    height: 177,
    rx: 51,
    transform: "rotate(-15 108.893 27.012)",
    stroke: "url(#paint6_linear_160_23)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 135.893,
    y: 27.012,
    width: 102,
    height: 177,
    rx: 51,
    transform: "rotate(-15 135.893 27.012)",
    stroke: "url(#paint7_linear_160_23)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 162.893,
    y: 27.012,
    width: 102,
    height: 177,
    rx: 51,
    transform: "rotate(-15 162.893 27.012)",
    stroke: "url(#paint8_linear_160_23)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 190.893,
    y: 27.012,
    width: 102,
    height: 177,
    rx: 51,
    transform: "rotate(-15 190.893 27.012)",
    stroke: "url(#paint9_linear_160_23)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 216.893,
    y: 27.012,
    width: 102,
    height: 177,
    rx: 51,
    transform: "rotate(-15 216.893 27.012)",
    stroke: "url(#paint10_linear_160_23)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_23",
    x1: -2.5,
    y1: 26.6584,
    x2: -2.5,
    y2: 204.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C9F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_160_23",
    x1: 24.7803,
    y1: 26.6584,
    x2: 24.7803,
    y2: 204.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C9F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_160_23",
    x1: 51.7803,
    y1: 26.6584,
    x2: 51.7803,
    y2: 204.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C9F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_160_23",
    x1: 78.7803,
    y1: 26.6584,
    x2: 78.7803,
    y2: 204.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C9F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_160_23",
    x1: 105.78,
    y1: 26.6584,
    x2: 105.78,
    y2: 204.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C9F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_160_23",
    x1: 132.78,
    y1: 26.6584,
    x2: 132.78,
    y2: 204.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C9F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_160_23",
    x1: 159.78,
    y1: 26.6584,
    x2: 159.78,
    y2: 204.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C9F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_160_23",
    x1: 186.78,
    y1: 26.6584,
    x2: 186.78,
    y2: 204.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C9F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_160_23",
    x1: 213.78,
    y1: 26.6584,
    x2: 213.78,
    y2: 204.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C9F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_160_23",
    x1: 241.78,
    y1: 26.6584,
    x2: 241.78,
    y2: 204.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C9F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_160_23",
    x1: 267.78,
    y1: 26.6584,
    x2: 267.78,
    y2: 204.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C9F4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup33);
export default __webpack_public_path__ + "static/media/group-33.417ad49875dfdc4e00f74a7667838b81.svg";
export { ForwardRef as ReactComponent };